export const PORTAL = 'SP';
export const POS = 'PM';
export const SMTP = 'smtp_service';
